import NVC_Opt from './NVC'
import $ from 'jquery'
export default () => {
    window.NVC_Opt = NVC_Opt
    window.$ = $
	window.jQuery = $
}


// WEBPACK FOOTER //
// ./src/libs/CONST.js